import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const CarIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M12.82 7C13.47 7 14 7.53 14 8.18V10H2V8.18C2 7.53 2.53 7 3.18 7H12.82ZM12.82 5H3.18C1.43 5 0 6.43 0 8.18V10V12H2H14H16V10V8.18C16 6.43 14.57 5 12.82 5Z"
      fill="#183558"
    />
    <path
      d="M10.44 3C11.3 3 12 3.7 12 4.56V5H4V4.56C4 3.7 4.7 3 5.56 3H10.44ZM10.44 1H5.56C3.6 1 2 2.6 2 4.56V5V7H4H12H14V5V4.56C14 2.6 12.4 1 10.44 1Z"
      fill="#183558"
    />
    <path
      d="M16 4.79281C16 5.10712 15.8143 5.39175 15.5267 5.51841L14.66 5.9C13.9 6.23 13 5.74 13 5C13 4.45 13.51 4 14.15 4H15.2072C15.645 4 16 4.35496 16 4.79281Z"
      fill="#183558"
    />
    <path
      d="M0 4.79281C0 5.10712 0.185676 5.39175 0.473336 5.51841L1.34 5.9C2.1 6.23 3 5.74 3 5C3 4.45 2.49 4 1.85 4H0.792815C0.354956 4 0 4.35495 0 4.79281Z"
      fill="#183558"
    />
    <path
      d="M13 13C12.45 13 12 12.55 12 12C12 11.45 12.45 11 13 11H14C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13H13Z"
      fill="#183558"
    />
    <path
      d="M14 12H13H14ZM14 10H13C11.9 10 11 10.9 11 12C11 13.1 11.9 14 13 14H14C15.1 14 16 13.1 16 12C16 10.9 15.1 10 14 10Z"
      fill="#183558"
    />
    <path
      d="M2 13C1.45 13 1 12.55 1 12C1 11.45 1.45 11 2 11H3C3.55 11 4 11.45 4 12C4 12.55 3.55 13 3 13H2Z"
      fill="#183558"
    />
    <path
      d="M3 12H2H3ZM3 10H2C0.9 10 0 10.9 0 12C0 13.1 0.9 14 2 14H3C4.1 14 5 13.1 5 12C5 10.9 4.1 10 3 10Z"
      fill="#183558"
    />
  </svg>
));

export default CarIcon;
